var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWhiteMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mail",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.30403 0H36.0964C37.3689 0 38.4004 1.02276 38.4004 2.28439V4.31887L20.3748 14.9095C19.6506 15.3349 18.75 15.3349 18.0258 14.9095L0 4.31887V2.28439C0 1.02276 1.03155 0 2.30403 0ZM17.2427 19.2826C17.8349 19.6319 18.5112 19.8164 19.2002 19.8166C19.8893 19.8164 20.5655 19.6319 21.1577 19.2826L38.4004 9.15245V29.7156C38.4004 30.9772 37.3689 32 36.0964 32H2.30403C1.03155 32 0 30.9772 0 29.7156V9.15245L17.2427 19.2826Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhiteMail);
export default __webpack_public_path__ + "static/media/icon_white_mail.d1af9a0a0e74396af6d0710687b52141.svg";
export { ForwardRef as ReactComponent };